import {Box, styled, Subtitle1, KeyboardArrowLeftIcon, KeyboardArrowRightIcon, Chip, ImageList, CreateOutlinedIcon, Alert} from '../../../ui-library';

export const ContainerBox = styled(Box)`
    display: flex;
    flex-direction: column;
    margin-top: 40px;
`;

export const ClassListTitle = styled(Subtitle1)`
    ${({ theme }) => theme.typography.subtitle1};
`;

export const ContainerBoxClassList = styled(Box)<{ inputerror?: string }>`
    display: flex;
    height: fit-content;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid  ${({ theme, inputerror = '' }) => (inputerror ? theme.palette.error.main : theme.palette.grey['300'])};
    border-radius: 10px;
    margin-top: 40px;
`;

export const InsideBox = styled(Box)`
    display: flex;
    padding: 41px 85px 41px 85px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const P = styled(Subtitle1)`
    margin-top: 22px;
    ${({ theme }) => theme.typography.body1};
`;

export const ContainerBoxWithImages = styled(Box)<{
    inputerror?: boolean,
    isinhovermode?: boolean,
    isineditmode?: boolean
}>`
    display: flex;
    flex-direction: column;
    padding: 20px 16px;
    border: ${({ theme, inputerror = false, isinhovermode = false, isineditmode = false }) => {
        if (inputerror) {
            return `1px solid ${theme.palette.error.main}`;
        } else if (isinhovermode && isineditmode) {
            return `1px solid ${theme.palette.primary.main}`;
        } else if (isinhovermode) {
            return `1px solid ${theme.palette.grey['400']}`;
        }

        return `1px solid ${theme.palette.grey['300']}`;
    }};
    border-radius: 10px;
    margin-top: 40px;
`;

export const ContainerBoxWithImagesInner = styled(Box)`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const KeyboardArrowIconL = styled(KeyboardArrowLeftIcon)`
    color: ${({ theme }) => theme.palette.grey['700']};
    cursor: pointer;
`;

export const KeyboardArrowIconR = styled(KeyboardArrowRightIcon)`
    color: ${({ theme }) => theme.palette.grey['700']};
    cursor: pointer;
`;
export const ContainerBoxWithImagesAll = styled(Box)`
    display: flex;
    flex-direction: row;
`;

export const ChipClassName = styled(Chip)`
    width: fit-content;
    background-color: ${({ theme }) => theme.palette.grey[200]};
    & .MuiChip-label{
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.16px;
        color: ${({ theme }) => theme.palette.grey[900]};
    },
`;

export const ImageListClassList = styled(ImageList)`
    overflow: hidden;
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fit, minmax(88x,1fr)) !important;
    grid-auto-columns: minmax(88px, 1fr);
`;

export const ProgressContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const CreateOutlinedIconClass = styled(CreateOutlinedIcon)`
    margin-left: auto;
    fill: ${({ theme }) => theme.palette.grey[700]};
    cursor: pointer;
`;

export const AlertFull = styled(Alert)`
    margin-top: 30px;
    background-color: #FDEDF0;
    width: 700px;
`;
